/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { Directive } from '@angular/core';

@Directive({
    selector: '[appSubjectAltNameValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: SubjectAltNameValidationDirective, multi: true }]
})

export class SubjectAltNameValidationDirective implements Validator {
    public validate(control: AbstractControl): { [key: string]: any } | null {
        return subjectAltNameValidation(control);
    }
}

/**
 * Subject alt name check. Can include domain/sub-domain names, ip addresses and email addresses.
 * @param control
 */
export function subjectAltNameValidation(control: any): any {
    if (!control || !control.value || control.value === '') {
        return null;
    }

    const value = control.value.toLowerCase();
    // RFC 2822 compliant regex
    // eslint-disable-next-line
    let san = value.match(/^((\d{1,3}\.){3}\d{1,3}|([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}|[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})$/);

    if (san && san[0] === control.value.toLowerCase()) {
        return null;
    } else {
        return { invalidSAN: 'invalid_san' };
    }
}
